import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameInitials'
})
export class NameInitialsPipe implements PipeTransform {

  private removeDiacritics(text: string): string {
    return text.normalize('NFD').replaceAll(/[\u0300-\u036f]/g, "")
  }

  transform(value: string | undefined): string {
    if (!value) return ''
    const cleanedValue = this.removeDiacritics(value)
    const words = cleanedValue.trim().split(/\s+/)
    const initials = words.slice(0, 2).map(word => word.charAt(0).toUpperCase()).join('')
    return initials
  }
}